<!-- 
    描述：场地管理  -- 新增/编辑页
    时间： 2020/9/28
    Created by zl
-->
<template>
	<div class="filed-info-layout">
		<div class="common-top"
			 ref="formRef">
			<el-form label-width="130px"
					 :model="msgForm"
					 :rules="msgRule">
				<el-row>
					<el-col :span="12"
							:offset="6">
						场地名称：<span>{{msgForm.fieldName}}</span>
					</el-col>
					<el-col :span="12"
							:offset="6">
						场地所属单位：<span>{{msgForm.subCompany}}</span>
					</el-col>
					<el-col :span="12"
							:offset="6">
						场地地址：<span>{{msgForm.address}}</span>
					</el-col>
				</el-row>
				<el-divider content-position="left">
					会议室信息
				</el-divider>
				<div class="add-area"
					 v-model="msgForm.roomInformation">
					<div class="add-box">
						<el-row>
							<el-col>
								<el-form-item :prop="
                                            roomInformation.roomName"
											  label="会议室名称：">
									<el-input type="number"
											  v-model="roomInformation.roomName"></el-input>
								</el-form-item>
							</el-col>
							<el-col>
								<el-form-item label="会议室类型：">
									<el-select v-model="roomInformation.type"
											   placeholder="请选择场地所属单位">
										<el-option label="测试"
												   value="1"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col>
								<el-form-item label="场地容纳人数：">
									<el-select v-model="roomInformation.capacity"
											   placeholder="请选择场地容纳人数">
										<el-option label="测试"
												   value="1"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col>
								<el-form-item label="会议室价格：">
									<el-input type="number"
											  v-model="roomInformation.roomPrice"></el-input>
								</el-form-item>
							</el-col>
							<el-col>
								<el-form-item label="会议室配置信息："
								                >
									<el-checkbox-group v-model="roomInformation.placeMsg">
										<el-checkbox label="1"></el-checkbox>
										<el-checkbox label="2"></el-checkbox>
										<el-checkbox label="3"></el-checkbox>
										<el-checkbox label="4"></el-checkbox>
										<el-checkbox label="5"></el-checkbox>
										<el-checkbox label="6"></el-checkbox>
										<el-checkbox label="7"></el-checkbox>
									</el-checkbox-group>
								</el-form-item>
							</el-col>
							<el-col>
								<el-form-item label="场地照片："
											  :prop="
                                            'picture'
                                        "></el-form-item>
							</el-col>

						</el-row>
					</div>
				</div>
			</el-form>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'
export default {
	components: {},
	props: {
		childH: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			msgForm: {
				fieldName: '', //场地名称
				subCompany: '', //场地所属单位
				adress: '', //详细地址
				roomInformation: {
                    type: '招标室',
                    capacity:'50',
                    roomName:'新地',
                    roomPrice:'1000'
				}
			},
			msgRule: {
				name: [
					{
						required: true,
						message: '请填写场地名称',
						tirgger: 'blur'
					}
				],
				dwName: [
					{
						required: true,
						message: '请选择场地所属单位',
						tirgger: 'blur'
					}
				]
			},
			msg: [],
			meetingList: [],
			boxH: 0
		}
	},
	methods: {
		//点击会议室信息
		addMettingInfo() {
			this.msgForm.meetingList.push({
				id: '',
				hysType: '',
				placeNum: '',
				placePrice: 1,
				placeMsg: '',
				placeImg: []
			})
		},

		// 删除一条记录
		deleteRow(index) {
			this.msgForm.meetingList.splice(index, 1)
		}
	}
}
</script>
<style lang='less' scoped>
.filed-info-layout {
	.common-top {
		padding: 20px 0;
		.special-item {
			/deep/ .el-form-item__content {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-around;
			}
			/deep/ .el-select {
				flex: 1;
				width: 33.3%;
			}
			/deep/ .el-select + .el-select {
				margin-left: 15px;
			}
			.detail-msg {
				margin-top: 15px !important;
			}
		}
	}
	.el-icon-circle-plus {
		font-size: 30px;
		color: #009900;
		cursor: pointer;
	}
	.add-area {
		.add-box {
			width: 50%;
			margin: 0 auto;
			padding: 20px;
			border: 1px solid #aaa;
			position: relative;
			margin-bottom: 20px;
		}
		.el-icon-error {
			position: absolute;
			top: -15px;
			right: -15px;
			font-size: 30px;
			color: crimson;
			background-color: #fff;
			cursor: pointer;
		}
	}
}
</style>
